// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1LbDF","savePackageButton":"ClientWallet_savePackageButton__1gIuK"};